export enum PreAssignmentSubGridColumnId {
  ACCRUED_INTEREST = 'PRE_ASSIGNMENT_ACCRUED_INTEREST',
  ALL_IN_PRICE = 'PRE_ASSIGNMENT_ALL_IN_PRICE',
  END_CONSIDERATION = 'PRE_ASSIGNMENT_END_CONSIDERATION',
  HAIRCUT = 'PRE_ASSIGNMENT_HAIRCUT',
  HAIRCUT_TYPE = 'PRE_ASSIGNMENT_HAIRCUT_TYPE',
  INITIATOR_BOOK = 'PRE_ASSIGNMENT_INITIATOR_BOOK',
  INITIATOR_STRATEGY = 'PRE_ASSIGNMENT_INITIATOR_STRATEGY',
  MY_ENTITY = 'PRE_ASSIGNMENT_MY_ENTITY',
  NOTIONAL = 'PRE_ASSIGNMENT_NOTIONAL',
  RATE = 'PRE_ASSIGNMENT_RATE',
  REPO_INTEREST = 'PRE_ASSIGNMENT_REPO_INTEREST',
  START_CONSIDERATION = 'PRE_ASSIGNMENT_START_CONSIDERATION',
  START_CONSIDERATION_OVERRIDE = 'PRE_ASSIGNMENT_START_CONSIDERATION_OVERRIDE'
}
